import { ICheckbox, TCheckboxSize, TCheckboxType } from './interfaces';
import styles from './checkbox.styles';
import React, { useState } from 'react';

import iconCheckmark from '@img/icons/checkmark.svg';

function HiddenCheckbox(props: any) {
    return (
        <input
            className={'hidden-checkbox'}
            type="checkbox"
            aria-label={`checkbox ${props.ariaLabel || props.name || ''}`}
            {...props} />
    );
}

function SimpleCheckbox() {
    return (
        <div className={'styled-checkbox'}>
            <img loading="lazy" src={iconCheckmark} alt={'checkmark'} />
        </div>
    );
}

function Switch2(props: any) {
    return (
        // <div className="onoffswitch">
        //     <input type="checkbox" name="onoffswitch" className="onoffswitch-checkbox" id="myonoffswitch" checked/>
        //     <label className="onoffswitch-label" htmlFor ="myonoffswitch">
        //         {props.checked ?
        //              <span className="onoffswitch-inner"></span>
        //             :
        //             <span className="onoffswitch-switch"></span>
        //         }
        //         <span className="onoffswitch-inner"></span>
        //         <span className="onoffswitch-switch"></span>
        //     </label>
        // </div>

        <div className={'styled-switch-on-off'}>
            <div className={'switch-circle'}>
                {props.checked ?
                    <span className={'onoffswitch-inner'}>On</span>
                        :
                    <span className={'onoffswitch-switch'}>Off</span>
                }
            </div>
        </div>
    );
}

function Switch() {
    return (
        <div className={'styled-switch'}>
            <div className={'switch-circle'}></div>
        </div>
    );
}

function StyledCheckbox(props: any) {
    switch (props.type) {
        case 'CHECKBOX': return (<SimpleCheckbox />);
        case 'SWITCH': return (<Switch />);
        case 'SWITCH2': return (<Switch2 checked={props.checked}/>);
        default: return (<SimpleCheckbox />);
    }
}

function CheckboxContainer({ children }: { children: any }) {
    return (
        <div className={'container-checkbox'}>
            {children}
        </div>
    );
}

function Checkbox({ ariaLabel, checked, onChange, children, size, type, name, disabled, useParentState }: ICheckbox) {
    const [internalChecked, setChecked] = useState(!!checked);
    const internalSize: TCheckboxSize = size || 'SMALL';
    const internalType: TCheckboxType = type || 'CHECKBOX';

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const ch = event.target.checked;

        setChecked(ch);
        onChange(ch, name);
    }

    return (
        <label className={styles.checkbox(useParentState ? checked : internalChecked, internalSize, internalType, disabled)}>
            <CheckboxContainer>
                <HiddenCheckbox
                    ariaLabel={ariaLabel}
                    checked={useParentState ? checked : internalChecked}
                    disabled={!!disabled}
                    onChange={handleCheckboxChange} />

                <StyledCheckbox type={internalType} checked={useParentState ? checked : internalChecked}/>
            </CheckboxContainer>
            <span className="label">{children}</span>
        </label>
    );
}

export default Checkbox;
